module.exports = __webpack_public_path__ + "img/exit_15.3c78824b.svg";